import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication";

const CommitteeForm = {
  committeeName: "",
  committeeAdmin: [],
  // committeeAdmin: {},
  committeeDescription: "",
  secretCommittee: false,
  status: true,
  committeeImage: "",
  fromName: "Broward Partnerships for Kids",
  fromEmail: "bpk@browardpartnershipsforkids.org",
};
// create slice
const name = "committee";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const committeeActions = { ...slice.actions, ...extraActions };
export const committeeReducer = slice.reducer;

function createInitialState() {
  return {
    CreateCommitteeResponse: {},
    committeeList: {},
    getCommitteeByIDResponse: {},
    committeeForm: CommitteeForm,
    getCommitteeHomePageIntegrationDataResponse: {},
    updateCommitteeHomePageResponse: {}, //update api response
    committeeMemberList: {},
    committeeID: {},
    committeeLabels: {},
    loading: false,
    getSliderList: {},
  };
}

function createReducers() {
  return {
    updateCommitteeForm,
    resetCommitteeForm,

    updateCommitteeHomePageReponseData,
    setCommittieID,
  };
}

function setCommittieID(state, action) {
  state.committeeID = action?.payload;
}

function updateCommitteeForm(state, action) {
  state.committeeForm = action?.payload;
}

function resetCommitteeForm(state, action) {
  state.committeeForm = CommitteeForm;
}
function updateCommitteeHomePageReponseData(state, action) {
  state.getCommitteeHomePageIntegrationDataResponse.data = action?.payload;
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  return {
    getCommitteeList: getCommitteeList(), //master committee list
    // getCommitteeListForSlider: getCommitteeListForSlider(), //master committee list
    getCommitteeByID: getCommitteeByID(), //master get for edit
    CreateCommittee: CreateCommittee(), //master create
    updateCommittee: updateCommittee(), //master update
    getCommitteeMemberByCommitteeID: getCommitteeMemberByCommitteeID(), //site

    getCommitteeHomePageIntegrationData: getCommitteeHomePageIntegrationData(),
    updateCommitteeHomePage: updateCommitteeHomePage(),

    getAllCommittieeLabels: getAllCommittieeLabels(),

    sliderForHomePage: sliderForHomePage(),
  };

  /* slider for Home Page */
  function sliderForHomePage() {
    return createAsyncThunk(
      `${name}/sliderForHomePage`,
      async (params = "") =>
        await fetchWrapper.get(`${baseUrl}/committee/home-page?${params}`)
    );
  }

  /* get committee list */
  function getCommitteeList() {
    return createAsyncThunk(
      `${name}/getCommitteeList`,
      //  async (params) => await fetchWrapper.get(`${baseUrl}/committee${params}`)
      async (params = "") =>
        await fetchWrapper.get(`${baseUrl}/committee/my-committees${params}`)
    );
  }

  /* get Committee List For Slider */
  function getCommitteeListForSlider() {
    return createAsyncThunk(
      `${name}/getCommitteeListForSlider`,
      //  async (params) => await fetchWrapper.get(`${baseUrl}/committee${params}`)
      async (params = "") =>
        await fetchWrapper.get(`${baseUrl}/committee${params}`)
    );
  }

  /* get committee by ID */
  function getCommitteeByID() {
    return createAsyncThunk(
      `${name}/getCommitteeByID`,
      async (id) => await fetchWrapper.get(`${baseUrl}/committee/${id}`)
    );
  }

  /* create new committee */
  function CreateCommittee() {
    return createAsyncThunk(
      `${name}/CreateCommittee`,
      async (params) => await fetchWrapper.post(`${baseUrl}/committee`, params)
    );
  }

  /* create update committee */
  function updateCommittee() {
    return createAsyncThunk(
      `${name}/updateCommittee`,
      async (params) => {
        const id = params instanceof FormData ? params.get("_id") : params?._id;
        return await fetchWrapper.patch(`${baseUrl}/committee/${id}`, params);
      }
    );
  }

  /*get Committee Member By Committee ID */
  function getCommitteeMemberByCommitteeID() {
    return createAsyncThunk(
      `${name}/getCommitteeMemberByCommitteeID`,
      async ({ id, page, limit, status }) =>
        await fetchWrapper.get(
          `${baseUrl}/users/committee/${id}?limit=${limit}&page=${page}&status=${status}`
        )
    );
  }

  /* get Committee HomePage Integration Data */
  function getCommitteeHomePageIntegrationData() {
    return createAsyncThunk(
      `${name}/homepage`,
      async (id) =>
        await fetchWrapper.get(`${baseUrl}/committee/homepage/${id}`)
    );
  }

  /* update Committee HomePage */
  function updateCommitteeHomePage() {
    return createAsyncThunk(
      `${name}/updateCommitteeHomePage`,
      async (params) =>
        await fetchWrapper.patch(
          `${baseUrl}/committee/homepage/${params.get("_id")}`,
          params
        )
    );
  }

  //getAllCommittieeLabels
  function getAllCommittieeLabels() {
    return createAsyncThunk(
      `${name}/getAllCommittieeLabels`,
      async () => await fetchWrapper.get(`${baseUrl}/committee/labels`)
    );
  }
}

function createExtraReducers(builder) {
  builder
    //get Slider List
    .addCase(extraActions.sliderForHomePage.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.sliderForHomePage.fulfilled, (state, action) => {
      state.loading = false;
      state.getSliderList = action.payload;
    })
    .addCase(extraActions.sliderForHomePage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })
    //committee list
    .addCase(extraActions.getCommitteeList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getCommitteeList.fulfilled, (state, action) => {
      state.loading = false;
      state.committeeList = action?.payload;
    })
    .addCase(extraActions.getCommitteeList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //committee ID
    .addCase(extraActions.getCommitteeByID.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getCommitteeByID.fulfilled, (state, action) => {
      state.loading = false;
      state.getCommitteeByIDResponse = action?.payload;
    })
    .addCase(extraActions.getCommitteeByID.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //create committee
    .addCase(extraActions.CreateCommittee.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.CreateCommittee.fulfilled, (state, action) => {
      state.loading = false;
      state.CreateCommitteeResponse = action?.payload;
    })
    .addCase(extraActions.CreateCommittee.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //get Committee HomePage Integration Data
    .addCase(
      extraActions.getCommitteeHomePageIntegrationData.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.getCommitteeHomePageIntegrationData.fulfilled,
      (state, action) => {
        state.loading = false;
        state.getCommitteeHomePageIntegrationDataResponse = action?.payload;
      }
    )
    .addCase(
      extraActions.getCommitteeHomePageIntegrationData.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    )

    //update Committee HomePage
    .addCase(extraActions.updateCommitteeHomePage.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.updateCommitteeHomePage.fulfilled,
      (state, action) => {
        state.loading = false;
        state.updateCommitteeHomePageResponse = action?.payload;
      }
    )
    .addCase(extraActions.updateCommitteeHomePage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //get CommitteeMember By CommitteeID
    .addCase(extraActions.getCommitteeMemberByCommitteeID.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.getCommitteeMemberByCommitteeID.fulfilled,
      (state, action) => {
        state.loading = false;
        state.committeeMemberList = action?.payload;
      }
    )
    .addCase(
      extraActions.getCommitteeMemberByCommitteeID.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    )
    //get labels for committie dropDown
    .addCase(extraActions.getAllCommittieeLabels.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getAllCommittieeLabels.fulfilled, (state, action) => {
      state.loading = false;
      state.committeeLabels = action?.payload?.data;
    })
    .addCase(extraActions.getAllCommittieeLabels.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    });
}
